import React from 'react';
import { Navigate, Outlet } from 'react-router-dom'

type Props = {
	hasAccess: boolean;
}

const AuthenticatedRoute = (props: Props) => {
	const { hasAccess } = props;
	return hasAccess ? <Outlet /> : <Navigate to={'/auth'} />
}

export default AuthenticatedRoute